import { forwardRef } from 'react';

interface FieldProps {
  label: string;
  type: string;
}

export const Field = forwardRef<any, FieldProps>(({ label, type }, ref) => {
  return (
    <div>
      <label>{label}</label>
      <input ref={ref} type={type}/>
    </div>
  );
});
